/**
 * WordPress dependencies
 */
import { G, Icon, Path, Polygon, Rect, SVG } from '@wordpress/components';

export const AudiogramIcon = () => (
	<SVG
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 199 166.5"
		width="24"
		height="24"
	>
		<defs>
			<style>
				{
					'.prefix__cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:13px}'
				}
			</style>
		</defs>
		<path
			className="prefix__cls-1"
			d="M6.5 0v166M130.5.5v166M37.5 23.5v115M99.5 23.5v115M161.5 23.5v115M68.5 52.5v61M192.5 50.5v61"
		/>
	</SVG>
);
